export const SET_CATEGORY_DISCOUNTS = 'SET_CATEGORY_DISCOUNTS'
export const SET_SELECTED_CATEGORY_DISCOUNT = 'SET_SELECTED_CATEGORY_DISCOUNT'
export const SET_SHOW_DISCOUNT_INFO_MODAL = 'SET_SHOW_DISCOUNT_INFO_MODAL'
export const SET_SELECTED_MODULE_FOR_DISCOUNT = 'SET_SELECTED_MODULE_FOR_DISCOUNT'
export const SET_CATEGORY_PRICE_DESCRIPTIONS = 'SET_CATEGORY_PRICE_DESCRIPTIONS'
export const SET_CATEGORY_DISCOUNT_IS_EXIST_ERROR = 'SET_CATEGORY_DISCOUNT_IS_EXIST_ERROR'
